import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Layout } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import DocumentForm from 'components/documentForm'
import { answerRequest } from '~/states/modules/answer'
import { getTemplateDetail } from 'states/modules/editTemplate'
import { listQuestion } from 'states/modules/question'

function AddContract() {
	const loadingAnswer = useSelector(({ answer }) => answer.loadingAnswer)
	const { loading, textType } = useSelector(({ question }) => question)
	const { data: document_template, loading: loadingTemplate } = useSelector(
		({ editTemplate }) => editTemplate
	)

	const dispatch = useDispatch()

	const { modelId, documentTitle, parent } = useHistory().location.state

	const handleFinish = useCallback(
		(draft, history) => {
			dispatch(answerRequest({ history, draft }))
		},
		[dispatch]
	)

	useEffect(() => {
		dispatch(
			listQuestion({
				modelId,
				documentTitle,
				parent,
			})
		)
	}, [dispatch, modelId, documentTitle, parent])

	useEffect(() => {
		if (modelId) dispatch(getTemplateDetail({ id: modelId }))
	}, [modelId, dispatch])

	return loadingAnswer || loading || loadingTemplate ? (
		<Layout style={{ backgroundColor: '#fff' }}>
			<LoadingContainer>
				<lottie-player
					src="https://assets1.lottiefiles.com/private_files/lf30_4kmk2efh.json"
					background="transparent"
					speed="1"
					style={{ width: '300px', height: '300px' }}
					loop
					autoplay
				/>
			</LoadingContainer>
		</Layout>
	) : !loading && !loadingTemplate ? (
		<DocumentForm
			onFinish={handleFinish}
			cancelRoute={'/documents'}
			hasPreview={document_template.config?.hasPreview}
		/>
	) : null
}

export default AddContract

const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`
